import { useMemo, VoidFunctionComponent } from 'react';
import { Line } from '@react-three/drei';
import { Path } from 'three';
import { pathTo3D } from '@/lib/pathTo3D';

const RADIUS = 0.4;

interface Props {
    left: number;
    right: number;
    top: number;
    bottom: number;
    radius?: number;
    lineWidth?: number;
}

export const RoundedCornerBox: VoidFunctionComponent<Props> = ({
    left,
    right,
    top,
    bottom,
    radius = RADIUS,
    lineWidth = 1,
}) => {
    const points = useMemo(() => {
        const path = new Path();

        // draw line with rounded corners within bounds
        path.moveTo(left, bottom + radius);
        path.lineTo(left, top - radius);
        path.quadraticCurveTo(left, top, left + radius, top);
        path.lineTo(right - radius, top);
        path.quadraticCurveTo(right, top, right, top - radius);
        path.lineTo(right, bottom + radius);
        path.quadraticCurveTo(right, bottom, right - radius, bottom);
        path.lineTo(left + radius, bottom);
        path.quadraticCurveTo(left, bottom, left, bottom + radius);
        return pathTo3D(path.getPoints());
    }, [bottom, left, radius, right, top]);

    return <Line points={points} color={0xe0d0d0} lineWidth={lineWidth} />;
};
